import { useMemo } from "react";
import featureFlags from "../../../../featureFlags.json";

/** BE の PushTestFeatureConfig と同形 */
export type PushTestFeatureConfig = {
    enabled: boolean;
    allowedCognitoUsernames: string[];
};

export type FeatureFlags = {
    signup: boolean;
    pushTest: PushTestFeatureConfig;
};

export const useFeatureFlags = (): FeatureFlags => {
    return useMemo(() => featureFlags, []);
};
